<template>
  <div>
    <div
      v-if="isSearch && !visibleData.length"
      class="container mx-auto items-center justify-center w-full sm:w-11/12 md:w-10/12 my-6 grid grid-cols-2 gap-2 mt-12"
    >
      <div class="flex flex-col text-left col-span-2 md:col-span-1">
        <h1 class="text-secondary text-5xl md:text-7xl font-semibold mb-4">
          Oops!
        </h1>
        <div class="text-sm md:text-lg">
          Sorry we couldn’t find a result for your request.
        </div>
        <p class="text-xs md:text-sm mt-2">
          Please check your search and filter, then try again.
        </p>
      </div>
      <div class="col-span-2 md:col-span-1">
        <img src="@/assets/icons/search_null.svg" alt="" />
      </div>
    </div>

    <div v-else>
      <!-- //////// Desktop View Start //////// -->
      <div class="hidden md:flex flex-col text-right">
        <div class="p-2">
          <span v-if="allEmployees"
            >{{ currentPage == 0 ? currentPage + 1 : pageSize + currentPage }} -
            {{
              currentPage == 0
                ? pageSize > allEmployees.length
                  ? allEmployees.length
                  : pageSize
                : pageSize + visibleData.length
            }}
            of
            {{ allEmployees.length }}</span
          >
        </div>

        <!-- style="min-width: 900px" -->
        <div
          v-if="visibleData.length"
          class="overflow-y-auto hidden md:block rounded-t-xl text-primary"
        >
          <table style="min-width: 900px" class="w-full">
            <thead class="">
              <tr class="text-header font-bold shadow-md bg-dark-100 relative">
                <th
                  class="bg-newdirtyGreen border border-outlineGray font-bold capitalize text-sm tracking-wide text-header logo rounded-lg text-center whitespace-nowrap p-0"
                >
                  <div class="border px-2 py-3">
                    <input
                      type="checkbox"
                      :checked="allChecked"
                      @change="toggleCheckAll()"
                    />
                  </div>
                </th>

                <th
                  v-for="(title, index) in headers"
                  :key="index"
                  class="bg-newdirtyGreen border border-outlineGray font-bold uppercase text-sm tracking-wide text-header text-center whitespace-nowrap p-0"
                >
                  <div class="px-2 py-3 border">
                    {{ title }}
                  </div>
                </th>
              </tr>
            </thead>

            <tbody class="relative">
              <tr
                v-for="employee in visibleData"
                :key="employee.employeeId"
                class="hover:bg-easigrey group text-tableBpdy cursor-pointer relative"
              >
                <td
                  class="hover:bg-easigrey group bg-white text-tableBpdy cursor-pointer relative"
                >
                  <div class="text-center">
                    <input
                      :checked="selectedEmployees.includes(employee.employeeId)"
                      @change="selectEmployee(employee.employeeId)"
                      type="checkbox"
                      name=""
                      id=""
                    />
                  </div>
                </td>

                <td
                  @click="viewEmployee(employee.employeeId)"
                  class="border border-outlineGray text-left text-sm px-2 md:pl-8 py-3 bg-highlight group-hover:bg-highlight group-hover:border-outlineGray capitalize font-medium"
                >
                  <div class="flex items-center gap-2">
                    <div
                      v-if="employee.employee.profile.pfp"
                      class="border w-9 h-9 rounded-full overflow-hidden"
                    >
                      <img
                        class="w-full h-full object-cover"
                        :src="employee.employee.profile.pfp"
                        :alt="
                          employee.employee.profile.firstName +
                          ' ' +
                          employee.employee.profile.lastName
                        "
                      />
                    </div>
                    <div
                      v-else
                      class="bg-primary p-2 h-9 w-9 text-sm text-white text-center font-medium rounded-full"
                    >
                      {{ getAvatar(employee.employee).name }}
                    </div>
                    {{ display(employee.employee.profile.firstName) }}
                  </div>
                </td>
                <td
                  @click="viewEmployee(employee.employeeId)"
                  class="border border-outlineGray text-left text-sm px-2 md:pl-8 py-3 bg-highlight group-hover:bg-highlight group-hover:border-outlineGray capitalize font-medium"
                >
                  {{ display(employee.employee.profile.lastName) }}
                </td>

                <td
                  @click="viewEmployee(employee.employeeId)"
                  class="border border-outlineGray text-left text-sm px-2 md:pl-8 py-3 bg-white group-hover:bg-highlight group-hover:border-outlineGray capitalize font-medium"
                >
                  {{ formatAmount(employee.grossAmount) }}
                </td>
                <td
                  @click="viewEmployee(employee.profile.employeeId)"
                  class="border border-outlineGray text-left text-sm px-2 md:pl-8 py-3 bg-white group-hover:bg-highlight group-hover:border-outlineGray capitalize font-medium"
                >
                  {{ formatAmount(employee.netAmount) }}
                </td>
                <td
                  @click="viewEmployee(employee.employeeId)"
                  class="border border-outlineGray text-left text-sm px-2 md:pl-8 py-3 bg-white group-hover:bg-highlight group-hover:border-outlineGray capitalize font-medium"
                >
                  {{ formatDateString(employee.createdAt) }}
                </td>
                <td
                  @click="viewEmployee(employee.employeeId)"
                  class="border border-outlineGray text-left text-sm px-2 md:pl-8 py-3 bg-white group-hover:bg-highlight group-hover:border-outlineGray capitalize font-medium"
                  :class="getStatusColor(employee.payslipStatus)"
                >
                  {{ employee.payslipStatus }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!-- //////// Desktop View Ends ////////  -->

      <!-- //////// Mobile View Start //////// -->
      <div class="flex md:hidden w-full" v-if="visibleData.length">
        <div class="w-full">
          <div class="w-full flex items-center justify-between mb-2">
            <div class="flex items-center gap-2">
              <input
                type="checkbox"
                :checked="allChecked"
                class="h-4 w-4"
                @change="toggleCheckAll()"
              />

              <span class="text-dark-600">Select All</span>
            </div>

            <div>
              <span
                >{{
                  currentPage == 0 ? currentPage + 1 : pageSize + currentPage
                }}
                -
                {{
                  currentPage == 0
                    ? pageSize > allEmployees && allEmployees.length
                      ? allEmployees && allEmployees.length
                      : pageSize
                    : pageSize + visibleData.length
                }}
                of
                {{ allEmployees && allEmployees.length }}</span
              >
            </div>
          </div>
          <div v-if="loading" class="w-full">
            <easiLoader />
          </div>
          <div
            v-for="employee in visibleData"
            :key="employee.employeeId"
            class="w-full mb-8"
          >
            <table class="table-auto w-full overflow-y-auto">
              <tbody class="font-medium text-sm">
                <tr>
                  <td
                    class="w-4/12 border p-2 bg-newerDirtyBrown border-outlineGray"
                  >
                    <div class="flex items-center gap-2">
                      <input
                        :checked="
                          selectedEmployees.includes(employee.employeeId)
                        "
                        @change="selectEmployee(employee.employeeId)"
                        type="checkbox"
                        name=""
                        id=""
                      />
                      First Name
                    </div>
                  </td>
                  <td
                    @click="viewEmployee(employee.employeeId)"
                    class="cursor-pointer w-8/12 border border-outlineGray text-left p-2 px-3 bg-highlight"
                  >
                    <div class="flex items-center gap-2">
                      <div
                        v-if="employee.employee.profile.pfp"
                        class="border w-8 h-8 rounded-full overflow-hidden"
                      >
                        <img
                          class="w-full h-full object-cover"
                          :src="employee && employee.employee.profile.pfp"
                          :alt="
                            employee &&
                            employee.employee.profile.firstName +
                              ' ' +
                              employee &&
                            employee.employee.profile.lastName
                          "
                        />
                      </div>
                      <div
                        v-else
                        class="bg-primary uppercase p-2 h-8 w-8 text-center text-xs text-white font-medium rounded-full"
                      >
                        {{ getAvatar(employee && employee.employee).name }}
                      </div>
                      {{
                        display(employee && employee.employee.profile.firstName)
                      }}
                    </div>
                  </td>
                </tr>
                <tr
                  @click="viewEmployee(employee.employeeId)"
                  class="cursor-pointer"
                >
                  <td
                    class="w-4/12 border p-2 bg-newerDirtyBrown border-outlineGray"
                  >
                    <div class="flex items-center gap-2">Last Name</div>
                  </td>
                  <td
                    class="w-8/12 border border-outlineGray text-left p-2 bg-highlight px-3"
                  >
                    {{
                      display(employee && employee.employee.profile.lastName)
                    }}
                  </td>
                </tr>
                <tr
                  @click="viewEmployee(employee.employeeId)"
                  class="cursor-pointer"
                >
                  <td
                    class="w-4/12 border p-2 bg-newerDirtyBrown border-outlineGray"
                  >
                    <div class="flex items-center gap-2">Gross Pay</div>
                  </td>
                  <td
                    class="w-8/12 border border-outlineGray bg-white text-left p-2 px-3"
                  >
                    {{ formatAmount(employee.grossAmount) }}
                  </td>
                </tr>

                <tr
                  @click="viewEmployee(employee.employeeId)"
                  class="cursor-pointer"
                >
                  <td
                    class="w-4/12 border p-2 bg-newerDirtyBrown border-outlineGray"
                  >
                    <div class="flex items-center gap-2">Net Pay</div>
                  </td>
                  <td
                    class="w-8/12 border border-outlineGray bg-white text-left p-2 px-3"
                  >
                    {{ formatAmount(employee.netAmount) }}
                  </td>
                </tr>

                <tr
                  @click="viewEmployee(employee.employeeId)"
                  class="cursor-pointer"
                >
                  <td
                    class="w-4/12 border p-2 bg-newerDirtyBrown border-outlineGray"
                  >
                    <div class="flex items-center gap-2">Status</div>
                  </td>
                  <td
                    class="w-8/12 border border-outlineGray bg-white text-left p-2 px-3"
                    :class="getStatusColor(employee.payslipStatus)"
                  >
                    {{ employee.payslipStatus }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- //////// Mobile View End //////// -->
  </div>

  <!-- /////////// If there's no employee ////// -->
  <!-- <EmptyTable v-if="!isSearch && !(allEmployees && allEmployees.length)" /> -->

  <!-- /////////// Search Not found ////// -->

  <!-- //////// Pagination //////// -->
  <easiPagin
    v-if="allEmployees && allEmployees.length"
    :data="allEmployees"
    @page:update="updatePage"
    :currentPage="currentPage"
    :pageSize="pageSize"
    class="my-4"
  />
</template>

<script setup>
import { ref, reactive, onMounted, computed, watch } from "vue";
import { helperFunctions } from "@/composable/helperFunctions";
import { storeToRefs } from "pinia";
import { useDataStore } from "@/stores/data.js";
import { useToast } from "vue-toastification";
import { useRoute, useRouter } from "vue-router";
import EmptyTable from "@/components/global/emptyTable.vue";

const { formatAmount, getAvatar, formatDateString } = helperFunctions;
const route = useRoute();
const router = useRouter();
const store = useDataStore();
const { query } = store;

const props = defineProps({
  isSearch: {
    type: Boolean,
    default: false,
  },
  searchText: {
    type: String,
    default: "",
  },
  employees: {
    type: Array,
    default: [],
  },
  update: {
    type: Function,
  },
});

const emit = defineEmits(["selected"]);
const watchSearch = computed(() => props.isSearch);

const loading = ref(false);
const currentPage = ref(0);
const pageSize = ref(15);
const visibleData = ref([]);

const allChecked = ref(false);
const selectedEmployees = ref([]);
const headers = reactive([
  "First Name",
  "Last Name",
  "Gross Pay",
  "Net Pay",
  "Date Paid",
  "Status",
]);

const payrollForMonth = computed(() => store.getPayrollHistoryForMonth);

const payrollHasNoEmployee = computed(() => {
  return (
    payrollForMonth.value &&
    payrollForMonth.value.employeeDetails &&
    Object.keys(payrollForMonth.value.employeeDetails).length == 0
  );
});

onMounted(async () => {
  await updateVisibleData();
});

//////// Computed ////////
const allEmployees = computed(() =>
  payrollForMonth.value ? payrollForMonth.value.salaryRecords : []
);

watch(payrollForMonth, (val) => {
  updateVisibleData();
});

watch(watchSearch, () => {
  updateVisibleData();
});

//////// Functions ////////

const updatePage = (pageNumber) => {
  currentPage.value = pageNumber;
  updateVisibleData();
};

const updateVisibleData = async () => {
  if (payrollForMonth.value) {
    let datas = payrollForMonth.value.salaryRecords;

    if (props.isSearch) {
      datas = datas.filter(
        (emp) =>
          emp.employee.profile.firstName
            .toLowerCase()
            .includes(props.searchText.toLowerCase()) ||
          emp.employee.profile.lastName
            .toLowerCase()
            .includes(props.searchText.toLowerCase())
      );
    }

    console.log("DATAS", datas);

    visibleData.value = datas.slice(
      currentPage.value * pageSize.value,
      currentPage.value * pageSize.value + pageSize.value
    );

    // if we have 0 visible todos, go back a page
    if (visibleData.value.length == 0 && currentPage.value > 0) {
      updatePage(currentPage.value - 1);
    }
  } else {
    visibleData.value = [];
  }
};

const getStatusColor = (status) => {
  const colors = {
    SENT: "text-success",
    NOT_SENT: "text-secondary",
  };
  return colors[status];
};

const toggleCheckAll = () => {
  allChecked.value = !allChecked.value;

  if (allChecked.value) {
    allEmployees.value.forEach((emp) => {
      if (!selectedEmployees.value.includes(emp.employeeId)) {
        selectedEmployees.value.push(emp.employeeId);
      }
    });
  } else {
    selectedEmployees.value = [];
  }

  emit("selected", selectedEmployees.value);
};

const selectEmployee = async (arg) => {
  allChecked.value = false;

  if (selectedEmployees.value.includes(arg)) {
    selectedEmployees.value = [
      ...selectedEmployees.value.filter((id) => arg !== id),
    ];
  } else {
    selectedEmployees.value.push(arg);
  }

  emit("selected", selectedEmployees.value);
};

const viewEmployee = (id) => {
  if (typeof id == "string") {
    router.push({
      name: "PayslipDetails",
      query: { id: id },
    });
  }
};

const display = (arg) => {
  return arg ? arg : "N/A";
};
</script>

<style></style>
